export default [
  // 测试地址
  { path: '/sdkdemo', name: 'sdk', component: () => import('@/pages/demo/sdkDemo'), meta: { title: 'SDK Demo', code: 'sdk' } },
  { path: '/hmdemo', name: 'harmony', component: () => import('@/pages/demo/harmony'), meta: { title: 'harmony demo', code: 'harmony' } },
  { path: '/getAppInfo', name: 'getAppInfo', component: () => import('@/pages/demo/getAppInfo'), meta: { title: '获取app信息' } },
  { path: '/andPosition', name: 'andPosition', component: () => import('@/pages/demo/andPosition'), meta: { title: 'and position', code: 'sdk' } },
  { path: '/demo', name: 'demo', meta: { title: 'demo测试' }, component: () => import('@/pages/demo/index') },
  // 运营活动页
  { path: '/operate/invitereg', name: 'invitereg', component: () => import('@/pages/activity/operate/invite/invitereg'), meta: { title: '邀好友赚现金', code: 'invitereg' } },
  { path: '/operate/invite', name: 'invite', component: () => import('@/pages/activity/operate/invite/index'), meta: { title: '邀好友赚现金', code: 'invite' } },
  { path: '/operate/managebankcard', name: 'managebankcard', component: () => import('@/pages/activity/operate/redpacket/managebankcard'), meta: { title: '管理银行卡', code: 'managebankcard' } },
  { path: '/operate/redpacket', name: 'redpacket', component: () => import('@/pages/activity/operate/redpacket/index'), meta: { title: '我的红包', code: 'redpacket' } },
  { path: '/operate/redpacket/redEnvelope', name: 'redEnvelope2', component: () => import('@/pages/activity/operate/redpacket/redEnvelope'), meta: { keepAlive: true, title: '领取红包', code: 'redEnvelope' } },
  { path: '/operate/redpacket/redEnvelopeReceive', name: 'redEnvelopeReceive', component: () => import('@/pages/activity/operate/redpacket/redEnvelopeReceive'), meta: { title: '领取红包', code: 'redEnvelopeReceive' } },
  { path: '/operate/redpacket/login', name: 'redEnvelopeLogin', component: () => import('@/pages/activity/operate/redpacket/login'), meta: { title: '登录', code: 'redEnvelopeLogin' } },
  { path: '/operate/increaseRedpacketRecord', name: 'increase-redpacket-record', component: () => import('@/pages/activity/operate/increase-redpacket-record/index.vue'), meta: { title: '提额福利金明细' } },
  { path: '/operate/redbindbankcard', name: 'redpacket_bindbankcard', component: () => import('@/pages/activity/operate/redpacket/bindbankcard'), meta: { title: '选择银行卡' } },
  { path: '/operate/increase_money', name: 'operate_increase_money', component: () => import('@/pages/activity/operate/increase_money'), meta: { title: '专属提额' } },
  { path: '/operate/dynamic', name: 'dynamic', component: () => import('@/pages/activity/operate/dynamic'), meta: { title: '加载中...' } },
  { path: '/operate/dynamicthird', name: 'dynamicthird', component: () => import('@/pages/activity/operate/dynamic-third'), meta: { title: '加载中...' } },
  { path: '/operate/cost-disclosure', name: 'cost_disclosure', component: () => import('@/pages/activity/operate/CostDisclosure'), meta: { title: '个人贷款综合融资成本明示表' } },
  { path: '/operate/protocol', name: 'operate_protocol', component: () => import('@/pages/activity/operate/protocol'), meta: { title: '加载中...' } },
  // 其他活动
  { path: '/wx/yjhddownload', name: 'yjhd_download', component: () => import('@/pages/activity/wx/yjhd-download'), meta: { title: '下载易借' } },
  // 可能未使用，新增测试埋点验证
  { path: '/wx/smsdownload', name: 'wx_smsdownload', component: () => import('@/pages/activity/wx/sms-download'), meta: { title: '下载易借' } },
  { path: '/wxdownload', name: 'wxdownload', component: () => import('@/pages/activity/wx/download'), meta: { title: '下载易借', code: 'wxdownload' } },
  {
    path: '/activity-day/download',
    name: 'activity-day_download',
    component: () => import('@/pages/activity/activity-day/download'),
    meta: { title: '下载易借' }
  },
  { path: '/wx/memberdownload', name: 'memberdownload', component: () => import('@/pages/activity/wx/member-download'), meta: { title: '下载易借' } },
  { path: '/360/download', name: '360download', component: () => import('@/pages/activity/wx/360-download'), meta: { title: '下载易借' } },
  { path: '/channelReg', name: 'channelReg', component: () => import('@/pages/activity/register/channelReg'), meta: { title: '易借' } },
  { path: '/channeldownload', name: 'channeldownload', component: () => import('@/pages/activity/register/download'), meta: { title: '易借' } },
  { path: '/loanguide', name: 'loanguide', component: () => import('@/pages/activity/app/loanguide'), meta: { title: '借款指南', code: 'loanguide' } },
  // app中活动
  { path: '/app/wechat/page', name: 'wechatpage', meta: { title: '关注官方企业微信' }, component: () => import('@/pages/activity/app/wechat/page') },
  // 锡锡贷报错页回首页
  {
    path: '/app/backhome',
    name: 'back_home',
    meta: { title: '首页' },
    component: () => import('@/pages/activity/app/setup/back-home')
  },
  // 弃用
  // { path: '/app/sdkexplain', name: 'sdkexplain', meta: { title: '第三方SDK说明' }, component: () => import('@/pages/activity/app/setup/sdk-explain') },
  // { path: '/app/shareinfo', name: 'shareinfo', meta: { title: '第三方共享信息说明' }, component: () => import('@/pages/activity/app/setup/share-info') },
  { path: '/app/infoCollectedList', name: 'infoCollectedList', component: () => import('@/pages/activity/app/setup/info-collected-list'), meta: { title: '个人信息收集清单' } },
  { path: '/app/infoidentity', name: 'infoidentity', component: () => import('@/pages/activity/app/setup/info-identity'), meta: { title: '身份信息' } },
  { path: '/app/infoToEmail', name: 'infoToEmail', component: () => import('@/pages/activity/app/setup/info-to-email'), meta: { title: '发送到邮箱' } },
  { path: '/app/cancelAccount', name: 'cancelAccount', component: () => import('@/pages/activity/app/setup/cancelAccount'), meta: { title: '注销账户' } },
  { path: '/app/unionlogin', name: 'unionlogin', component: () => import('@/pages/activity/app/unionlogin'), meta: { title: '游戏中心', code: 'unionlogin' } }, // 闪电玩游戏联合登录
  { path: '/app/aboutus', name: 'appaboutus', component: () => import('@/pages/activity/app/appaboutus'), meta: { title: '关于我们', code: 'appaboutus' } },
  {
    path: '/xcx/yhphzs/aboutus',
    name: 'xcx_yhphzs_aboutus',
    component: () => import('@/pages/activity/xcx/yhphzs/aboutus.vue'),
    meta: { title: '关于我们' }
  },
  {
    path: '/xcx/yhzx/aboutus',
    name: 'xcx_yhzx_aboutus',
    component: () => import('@/pages/activity/xcx/yhzx/aboutus.vue'),
    meta: { title: '关于我们' }
  },
  {
    path: '/xcx/yhyx/aboutus',
    name: 'xcx_yhyx_aboutus',
    component: () => import('@/pages/activity/xcx/yhyx/aboutus.vue'),
    meta: { title: '关于我们' }
  },
  {
    path: '/xcx/yhqypt/aboutus',
    name: 'xcx_yhqypt_aboutus',
    component: () => import('@/pages/activity/xcx/yhqypt/aboutus.vue'),
    meta: { title: '关于我们' }
  },
  {
    path: '/xcx/yhshfw/aboutus',
    name: 'xcx_yhshfw_aboutus',
    component: () => import('@/pages/activity/xcx/yhshfw/aboutus.vue'),
    meta: { title: '关于我们' }
  },
  { path: '/loanRecommend', name: 'loanRecommend', component: () => import('@/pages/activity/app/loanRecommend'), meta: { title: '热门推荐' } },
  { path: '/appshare', name: 'appshare', component: () => import('@/pages/activity/app/appshare'), meta: { title: '推荐好友', code: 'appshare' } },
  { path: '/wxofficial', name: 'wxofficial', component: () => import('@/pages/activity/app/wxofficial'), meta: { title: '关注公众号', code: 'wxofficial' } },
  { path: '/wxofficialfollow', name: 'wxofficialfollow', component: () => import('@/pages/activity/app/wxofficialfollow'), meta: { title: '关注公众号', code: 'wxofficialfollow' } },
  { path: '/exchange', name: 'exchange', component: () => import('@/pages/activity/app/exchange'), meta: { title: '红包兑换流程', code: 'exchange' } },
  {
    path: '/app/fraudguid',
    name: 'app_fraudguid',
    meta: { title: '防诈骗指南' },
    component: () => import('@/pages/activity/app/fraud-guid')
  },
  // 当前小程序专用
  {
    path: '/app/userProtectCenter',
    name: 'userProtectCenter',
    meta: { title: '用户保护中心' },
    component: () => import('@/pages/activity/app/setup/user-protect-center')
  },
  {
    path: '/app/otherManage',
    name: 'otherManage',
    meta: { title: '其他管理' },
    component: () => import('@/pages/activity/app/setup/other-manage')
  },
  // 弃用
  // { path: '/app/welfare', name: 'welfare', component: () => import('@/pages/activity/app/welfare'), meta: { title: '老客福利社' } },
  // { path: '/app/welfare/download', name: 'welfare-download', component: () => import('@/pages/activity/app/welfare-download'), meta: { title: '老客福利社' } },

  // 现金签到
  { path: '/cash/index', name: 'cashSignIn', component: () => import('@/pages/activity/cash/index'), meta: { title: '现金签到' } },
  { path: '/cash/myGold', name: 'myGold', component: () => import('@/pages/activity/cash/my-gold'), meta: { title: '我的金币' } },
  { path: '/cash/drawAward', name: 'drawAwrad', component: () => import('@/pages/activity/cash/draw-award'), meta: { title: '金币抽奖' } },
  { path: '/cash/receiveAward', name: 'receiveAward', component: () => import('@/pages/activity/cash/receive-award'), meta: { title: '领取奖品' } },
  { path: '/cash/myAward', name: 'myAward', component: () => import('@/pages/activity/cash/my-award'), meta: { title: '我的奖品' } },
  { path: '/cash/makeGold', name: 'makeGold', component: () => import('@/pages/activity/cash/make-gold'), meta: { title: '赚金币' } },
  { path: '/cash/redEnvelope', name: 'redEnvelope', component: () => import('@/pages/activity/cash/red-envelope'), meta: { title: '抢现金红包' } },
  { path: '/cash/redEnvelopeDownload', name: 'redEnvelopeDownload', component: () => import('@/pages/activity/cash/red-envelope-download'), meta: { title: '下载易借速贷' } },

  // 老客福利社
  { path: '/welfare/tempquota/loading', name: 'welfare_tempquota_loading', component: () => import('@/pages/activity/welfare/tempquota/loading'), meta: { title: '老客福利社' } },
  { path: '/welfare/tempquota/getAmount', name: 'welfare_tempquota_getAmount', component: () => import('@/pages/activity/welfare/tempquota/getAmount'), meta: { title: '老客福利社' } },
  { path: '/welfare/tempquota/download', name: 'welfare_tempquota_download', component: () => import('@/pages/activity/welfare/tempquota/download'), meta: { title: '老客福利社' } },
  // 老客复借（送专属提额、优惠券、美团红包）
  {
    path: '/welfare/reborrow',
    name: 'welfare_reborrow',
    component: () => import('@/pages/activity/welfare/reborrow/index'),
    meta: { title: '老客福利社' }
  },
  {
    path: '/welfare/reborrow/download',
    name: 'welfare_reborrow_download',
    component: () => import('@/pages/activity/welfare/reborrow/download'),
    meta: { title: '老客福利社' }
  },

  // 树洞
  { path: '/treeHole/postMsg', name: 'postMsg', component: () => import('@/pages/activity/tree-hole/post-msg'), meta: { title: '发树洞留言' } },
  { path: '/treeHole/tree-hole-login', name: 'treeHoleLogin', component: () => import('@/pages/activity/tree-hole/tree-hole-login'), meta: { title: '登录' } },
  {
    path: '/treeHole',
    name: 'treeHole',
    component: () => import('@/pages/activity/tree-hole/index'),
    meta: { title: '树洞活动' },
    children: [
      {
        path: 'mine',
        name: 'mineMessage',
        component: () => import('@/pages/activity/tree-hole/mine'),
        meta: { title: '我的留言' }
      },
      {
        path: 'messageSquare',
        name: 'messageSquare',
        component: () => import('@/pages/activity/tree-hole/message-square'),
        meta: { title: '树洞广场' }
      }
    ]
  },
  // 借款用途确认
  {
    path: '/activity/loanuse',
    name: 'activity_loanuse',
    component: () => import('@/pages/activity/loan-use/index'),
    meta: { title: '借款用途确认' }
  },
  {
    path: '/activity/loanuse/result',
    name: 'activity_loanuse_result',
    component: () => import('@/pages/activity/loan-use/result'),
    meta: { title: '确认成功' }
  },
  // 还款领现金
  {
    path: '/activity/repaymentgold',
    name: 'activity_repaymentgold',
    component: () => import('@/pages/activity/repayment-gold/index'),
    meta: { title: '还款领现金' }
  },
  // 福利日
  {
    path: '/activity-day',
    name: 'activity_day',
    component: () => import('@/pages/activity/activity-day/index'),
    meta: { title: '福利日' }
  },
  // 绑定微信公众号
  {
    path: '/wx/wxoffical/bind',
    name: 'wxoffical_bind',
    component: () => import('@/pages/activity/wxoffical/bind'),
    meta: { title: '易花花' }
  },
  // 新广告H5产品列表
  {
    path: '/activity/loanmarket',
    name: 'activity_loanmarket',
    component: () => import('@/pages/activity/loan-market/index'),
    meta: { title: '精选产品' }
  },
  // 渠道导流登录页
  {
    path: '/guide/login',
    name: 'guide_login',
    component: () => import('@/pages/login/guide'),
    meta: { title: '易借' }
  },
  // 渠道登录链接异常跳转页面
  {
    path: '/404',
    name: '404',
    component: () => import('@/pages/404'),
    meta: { title: '易借' }
  }
]
